import i18n from "../i18n";
import React from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { AlertTriangle, RotateCw, Home } from "lucide-react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, info: null };
    }
    static getDerivedStateFromError(error) { return { hasError: true, error }; }
    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ErrorBoundary caught:", error, info);
        this.setState({ info });
    }
    reset = () => this.setState({ hasError: false, error: null, info: null });
    render() {
        if (!this.state.hasError) return this.props.children;
        return (
            <div className="min-h-screen flex items-center justify-center p-6 bg-background">
                <Card className="max-w-lg p-8 space-y-4" data-testid="error-boundary">
                    <div className="flex items-center gap-3">
                        <AlertTriangle className="w-10 h-10 text-destructive flex-shrink-0" />
                        <div>
                            <h2 className="text-2xl font-bold">{i18n.t("batch4.8d886c0ba6f2")}</h2>
                            <p className="text-sm text-muted-foreground">{i18n.t("batch4.d8d9713fb27f")}</p>
                        </div>
                    </div>
                    {this.state.error && (
                        <details className="text-xs bg-secondary p-3 rounded-lg">
                            <summary className="cursor-pointer font-semibold">{i18n.t("batch4.4be37be90bfc")}</summary>
                            <pre className="mt-2 font-mono whitespace-pre-wrap break-words">{String(this.state.error?.message || this.state.error)}</pre>
                        </details>
                    )}
                    <div className="flex gap-2">
                        <Button onClick={this.reset} className="flex-1 h-11"><RotateCw className="w-4 h-4 mr-2" />{i18n.t("batch4.042c862e4467")}</Button>
                        <Button onClick={() => { window.location.href = "/dashboard"; }} variant="outline" className="flex-1 h-11"><Home className="w-4 h-4 mr-2" />{i18n.t("batch4.8007defd3284")}</Button>
                    </div>
                </Card>
            </div>
        );
    }
}
